import React from 'react';
import PropTypes from "prop-types";
import { withRouter } from "react-router";

import {authenticationService} from "../service/autenticationService";

class LoginRequired extends React.Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    componentDidMount() {
        let user = authenticationService.validateToken();
        if(user == null){
            this.props.history.push('/login');
        }
    }

    render() {
        return (<div></div>);
    }
}

const SecuredSection = withRouter(LoginRequired)

export {SecuredSection}
